import axios from 'axios';

export default {
  index: (params = {}, config = {}) => axios.get('payments', { params, ...config }),
  show: (id, config = {}) => axios.get(`payments/${id}`, config),
  store: (payload = {}, config = {}) => axios.post('payments', payload, config),
  update: (id, payload = {}, config = {}) => axios.put(`payments/${id}`, payload, config),
  delete: (id, config = {}) => axios.delete(`payments/${id}`, config),
  clearBySale: (saleId, config = {}) => axios.delete(`payments/sale/${saleId}/clear`, config),
  taxPreview: (payload = {}, config = {}) => axios.post('expenses/tax-preview', payload, config),
};
